import { Spacer, SpacerProps } from '@sparemin/blockhead';
import React from 'react';

export type AuthSpacerProps<As extends React.ElementType = 'div'> =
  SpacerProps<As>;

/**
 * A `Spacer` component with pre-defined props that are required for many
 * auth forms/cards
 */
export function ForwardedAuthSpacer<As extends React.ElementType = 'div'>(
  {
    as,
    align = 'center',
    orientation = 'vertical',
    space = '15px',
    ...props
  }: AuthSpacerProps<As>,
  ref: React.ForwardedRef<React.ElementRef<As>>,
): React.ReactElement | null {
  const Component: React.ElementType = as ?? 'div';
  return (
    <Spacer
      as={Component}
      ref={ref}
      {...{ align, orientation, space }}
      {...props}
      style={{ width: '100%' }}
    />
  );
}

const AuthSpacer = React.forwardRef(ForwardedAuthSpacer) as <
  As extends React.ElementType = 'div',
>(
  props: AuthSpacerProps<As> & { ref?: React.Ref<React.ElementRef<As>> },
) => React.ReactElement | null;

export default AuthSpacer;
